import React, { Component } from "react";
import { Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControlLabel, TextField } from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import { IFuelGas } from "../../interfaces/IFuelGas";
import { RootState } from "../../reducers/rootReducer";
import { checkFuelgasName } from "../../services/fuelgasServices";
import { getSignature } from "../../utilities/helperFunctions";
import { modifyFuelGas } from "../../slices/fuelGasSlice";
import { AuthContextProps, withAuth } from "react-oidc-context";
import { getToken } from "../../utilities/helperFunctions";

interface IRenameFuelGasProps {
    fuelGas: IFuelGas;
}

interface OIDCAuth {
    auth?: AuthContextProps
 }

const mapStateToProps = (state: RootState) => {
    return {
        currentFurnaceId: state.scenarioSimulator.currentFurnaceId,
        fuelGases: state.fuelGas.fuelGases
    };
};

const mapDispatchToProps = dispatch => {
    return {
        modifyFuelGas: (newFuelGas: IFuelGas) => dispatch(modifyFuelGas(newFuelGas)),
    };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type IRenameFuelGasReduxProps = PropsFromRedux & IRenameFuelGasProps & OIDCAuth;

type IRenameFuelGasState = {
    showDialog: boolean;
    name: string;
    is_public: boolean;
    isNameAvailable: boolean;
    nameErrorMessage: string;
    showLoading: boolean;
}
class RenameFuelGas extends Component<IRenameFuelGasReduxProps, IRenameFuelGasState>{

    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            name: this.props.fuelGas.name,
            is_public: this.props.fuelGas.is_public ? this.props.fuelGas.is_public : false,
            isNameAvailable: false,
            nameErrorMessage: "",
            showLoading: false,
        }
    }

    toggleShowDialog() {

        let getName = this.props.fuelGas.is_public === true ? this.props.fuelGas.name.replace('(PUBLIC)', '') : this.props.fuelGas.name;
        this.setState({
            showDialog: !this.state.showDialog,
            name: getName,
            is_public: this.props.fuelGas.is_public ? this.props.fuelGas.is_public : false,
            isNameAvailable: false,
            nameErrorMessage: ""
        })
    }

    handleNameInput(event) {
        this.setState({
            name: event.target.value.toUpperCase()
        })
    }

    handleModifyFuelGas = async () => {
        if (!!this.state.name?.trim() && this.state.name !== "DEFAULT_DEMO") {
            this.setState({
                showLoading: true,
            })

            let setName = this.state.is_public === true ? this.state.name.trim() + "(PUBLIC)" : this.state.name.trim();

            let newFuelGas: IFuelGas = {
                ...this.props.fuelGas,
                id: this.props.fuelGas.id,
                name: setName,
                unit: this.props.fuelGas.unit,
                components: this.props.fuelGas.components,
                status: this.props.fuelGas.status,
                error_message: this.props.fuelGas.error_message,
                O2BridgeWall: this.props.fuelGas.O2BridgeWall,
                Pressure: this.props.fuelGas.Pressure,
                Temperature: this.props.fuelGas.Temperature,
                signature: this.props.fuelGas.signature,
                is_public: this.props.fuelGas.is_public,
                is_display_leave_popup: true,
                is_saved: false
            }

            try {
                let isNameInRedux = this.props.fuelGases.some(fuelgas => fuelgas.name === newFuelGas.name);
                if (isNameInRedux) {
                    this.setState({
                        isNameAvailable: true,
                        nameErrorMessage: "Name already exist!",
                        showLoading: false,
                    })
                } else {
                    const accessToken = await getToken(this.props.auth);
                    let isNameAvailable = await checkFuelgasName(newFuelGas, accessToken);
                    if (isNameAvailable.status) {
                        this.setState({
                            isNameAvailable: true,
                            nameErrorMessage: !!isNameAvailable.message ? isNameAvailable.message : "Name already exist!",
                            showLoading: false,
                        })
                    } else {
                        newFuelGas.signature = getSignature(newFuelGas);
                        this.props.modifyFuelGas(newFuelGas);
                        this.toggleShowDialog();
                        this.setState({
                            showLoading: false,
                        })
                    }
                }

            } catch (error) {
                // Api error hendaling 
                this.setState({
                    isNameAvailable: true,
                    showLoading: false,
                    nameErrorMessage: "Oops somthing went to wrong!"
                })
            }

        } else {
            this.setState({
                isNameAvailable: true,
                nameErrorMessage: "Please enter a name!",
                showLoading: false,
            })
        }
    }

    handleChangeIsPublic(event) {
        this.setState({
            is_public: !this.state.is_public
        })
    }

    render() {
        return (
            <div className="control-header element">
                <button
                    className="button"
                    onClick={() => this.toggleShowDialog()}
                    disabled={!!this.props.fuelGas && this.props.fuelGas.id.startsWith("_DEFAULT")}
                >
                    Rename
                </button>
                <Dialog open={this.state.showDialog} onClose={() => this.toggleShowDialog()} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Modify this fuel gas</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            To modify this fuel gas, please provide the following information:
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Name"
                            type="text"
                            fullWidth
                            defaultValue={this.state.name}
                            value={this.state.name}
                            onChange={(event) => this.handleNameInput(event)}
                            helperText={this.state.nameErrorMessage}
                            error={this.state.isNameAvailable}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.is_public}
                                    onChange={(event) => this.handleChangeIsPublic(event)}
                                    name="isPublic"
                                    value={this.state.is_public}
                                    color="primary"
                                    disabled={true}
                                />
                            }
                            label="Is Public?"
                        />
                    </DialogContent>
                    <DialogActions>
                        <button className="button" onClick={() => this.toggleShowDialog()}>
                            Cancel
                        </button>
                        <button className="button" onClick={() => this.handleModifyFuelGas()}>
                            Modify {this.state.showLoading === true && (
                                <Fade
                                    in={this.state.showLoading}
                                    style={{
                                        transitionDelay: this.state.showLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <CircularProgress size={11} />
                                </Fade>
                            )}
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

};

export default withAuth(connector(RenameFuelGas));